exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.type-row[data-v-54c49443] {\n  cursor: pointer;\n}\n", ""]);

// exports
